import React from 'react'

export const AssetPage = () => {
  return <div>@ToDo: Single Asset Page</div>
}

export default AssetPage
